import styled from 'styled-components';
import {TiStar} from 'react-icons/ti';

export const Tistar = styled(TiStar)`
  color: #894E07;
`
